const KEY = 'BT_CALENDAR_V2';

/**
 * Which calendar to render. The in-house grid is now the default everywhere —
 * `?calendar=v1` backs out and sticks, `?calendar=v2` opts back in.
 *
 * Why default-ON rather than opt-in: the extension has no URL of its own. It
 * renders inside web.whatsapp.com, so `window.location.search` is WhatsApp's
 * query string and `localStorage` is web.whatsapp.com's origin — there was no
 * way to pass `?calendar=v2` and the opt-in taken on the web app (a different
 * origin) never carried over. An opt-in flag therefore meant the extension
 * *always* rendered the old react-big-calendar view, which is where most
 * customers are. Defaulting ON is the only setting the extension can honour.
 *
 * Storage can throw in some extension contexts, so a failure falls back to the
 * new calendar (the default) rather than silently reverting to the old one.
 */
export function isCalendarV2Enabled(): boolean {
    try {
        const param = new URLSearchParams(window.location.search).get('calendar');
        if (param === 'v2') { window.localStorage.removeItem(KEY); return true; }
        if (param === 'v1') { window.localStorage.setItem(KEY, '0'); return false; }
        return window.localStorage.getItem(KEY) !== '0';
    } catch {
        return true;
    }
}
